<app-navbar></app-navbar>

<section class="blog-area ptb-100">
  <div class="container">
    <h3 class="widget-title" style="color: #ffffff; text-align: center">
      Wall Paintings of Proyash-Chattogram Students
    </h3>
    <hr />
    <div>
      <p style="color: white;">
        Graffiti and other artistic works are being painted on the wall by
        students of Proyash-Chattogram.
      </p>
      <section class="blog-area gallery-section">
        <div class="container">
          <div class="container">
            <div class="gallery-container">
              <div class="gallery">
                <a
                  *ngFor="let image of images"
                  class="gallery__item"
                  href="{{ image.src }}"
                  [title]="image.alt"
                >
                  <img
                    [src]="image.thumbnail"
                    [alt]="image.alt"
                    class="popup-btn"
                  />
                </a>
              </div>
            </div>
          </div>
        </div>
      </section>
    </div>
  </div>
</section>
